import { dispatchWindowEvent } from '@/utils/windowEvent';

const DEPLOY_VERSION_HEADER = 'x-deploy-version-admin';

// version detection rides along on responses the app is already making
// (success or error — both carry the header), instead of a dedicated poll
export const checkDeployVersionHeader = (headers) => {
  const observedVersion = headers?.[DEPLOY_VERSION_HEADER];
  if (observedVersion) dispatchWindowEvent('deployVersionObserved', observedVersion);
};
